import React, { Fragment } from "react";
import { Text, View } from "@react-pdf/renderer";
import styles from "./ItemTable.styles";

const TableRow = ({ items }) => {
  const getUniqueValue = array => {
    return array.map(item => item.AlarmId).filter((value, index, self) => self.indexOf(value) === index);
  };

  const getDescription = alarmId => {
    const selectedItem = items.filter(item => item.AlarmId === alarmId);
    return selectedItem[0]["Description"];
  };

  const getBackgroundColor = index => {
    return index % 2 === 0 ? "#eaf4fb" : "white";
  };

  const rows = getUniqueValue(items).map((item, index) => (
    <View style={[{ backgroundColor: getBackgroundColor(index) }, styles.tableRow]} key={item.AlarmId + "_" + index}>
      <Text style={styles.alarmId}>{item}</Text>
      <Text style={styles.description}>{getDescription(item)}</Text>
    </View>
  ));
  return <Fragment>{rows}</Fragment>;
};

export default TableRow;
